module.exports = __webpack_public_path__ + "static/media/example_spreadsheet.da03764c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guestlist/example_spreadsheet.png
// module id = 912
// module chunks = 68